import ClassTimetableForm from "./ClassTimetableForm";
import { CLASSTIMETABLE, DATATABLE_EXPORT } from "../../../../../../../Config/ApiUrl";

export const ClassTimetableSchema = {
	components: { ClassTimetableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			CLASSTIMETABLE, // simpan untuk digunakan nanti
			Endpoint: "", // awalnya kosong
			tableId: "classtime-table",
			rowData: {},
			formId: "classtime-form",
			tableColumns: [
				{
					title: "Week",
					type: "text",
					key: "week",
				},
				{
					title: "Start Date",
					type: "text",
					key: "start_date",
				},
				{
					title: "End Date",
					type: "text",
					key: "end_date",
				},
				{
					title: "星期一",
					type: "custom-html",
					key: "time_start_1",
					modifier: (value, row) => {
						const start = value || "";
						const end = row.time_end_1 || "";
						return `${start} - ${end}`;
					}
				},
				{
					title: "星期二",
					type: "custom-html",
					key: "time_start_2",
					modifier: (value, row) => {
						const start = value || "";
						const end = row.time_end_2 || "";
						return `${start} - ${end}`;
					}
				},
				{
					title: "星期三",
					type: "custom-html",
					key: "time_start_3",
					modifier: (value, row) => {
						const start = value || "";
						const end = row.time_end_3 || "";
						return `${start} - ${end}`;
					}
				},
				{
					title: "星期四",
					type: "custom-html",
					key: "time_start_4",
					modifier: (value, row) => {
						const start = value || "";
						const end = row.time_end_4 || "";
						return `${start} - ${end}`;
					}
				},
				{
					title: "星期五",
					type: "custom-html",
					key: "time_start_5",
					modifier: (value, row) => {
						const start = value || "";
						const end = row.time_end_5 || "";
						return `${start} - ${end}`;
					}
				},
				{
					title: "星期六",
					type: "custom-html",
					key: "time_start_6",
					modifier: (value, row) => {
						const start = value || "";
						const end = row.time_end_6 || "";
						return `${start} - ${end}`;
					}
				},
				{
					title: "星期日",
					type: "custom-html",
					key: "time_start_7",
					modifier: (value, row) => {
						const start = value || "";
						const end = row.time_end_7 || "";
						return `${start} - ${end}`;
					}
				},
				{
					title: "Note",
					type: "text",
					key: "note"
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "ClassTime",
				url: "", // nanti diisi saat created()
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "classtime-form",
					},
				],
				showFilter: false,
				showSearch: false,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
	},
};
